// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/modal/style/index.less
// module id = 950
// module chunks = 1